// removed by extract-text-webpack-plugin
module.exports = {"toggleButton":"src-components-toggleButton----toggleButton-module---toggleButton---3cU7J","tgl":"src-components-toggleButton----toggleButton-module---tgl---BR7ft","tglBtn":"src-components-toggleButton----toggleButton-module---tglBtn---3_UE2","checked":"src-components-toggleButton----toggleButton-module---checked---XFsxz","disabled":"src-components-toggleButton----toggleButton-module---disabled---BiMKf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/toggleButton/toggleButton.module.scss
// module id = 292
// module chunks = 95715928098905 114276838955818